<div class="ui one column unstackable grid">
  <div class="column">
    <div class="row">
      <label [ngClass]="{'disabled': readOnly}"
             style="margin: 10px 0px; display: inline-block; font-weight: bold; font-size: 0.92857143em;">
        Прикрепленные файлы:
      </label>
      <div class="ui icon buttons right floated">
        <button class="ui button"
                [ngClass]="{'disabled': readOnly}"
                (click)="onFileLoad()"
                suiPopup popupPlacement="top center" popupText="Прикрепить&nbsp;файл">
          <i class="paperclip icon"></i>
        </button>
        <button class="ui button"
                [ngClass]="{'disabled': !filesGrid.state.hasSelection}"
                suiPopup popupPlacement="top center" popupText="Удалить&nbsp;файл"
                (click)="onFileDelete()">
          <i class="trash alternate icon"></i>
        </button>
        <button class="ui button"
                [ngClass]="{'disabled': !filesGrid.state.hasSelection}"
                suiPopup popupPlacement="top center" popupText="Скачать&nbsp;файл"
                (click)="onFileDownload()">
          <i class="download alternate icon"></i>
        </button>
      </div>
    </div>
    <div class="row" style="clear: both;">
      <dx-grid
        #filesGrid
        [isDisabled]="readOnly"
        [options]="filesGridOptions"
        [data]="filesGridData"
        (rowsSelect)="onFilesRowSelect($event)"
        (rowsDeselect)="onFilesRowDeselect($event)">
      </dx-grid>
    </div>

  </div>
</div>
